import { render, staticRenderFns } from "./CardFieldWrap.vue?vue&type=template&id=fa7c4226&scoped=true"
import script from "./CardFieldWrap.vue?vue&type=script&lang=js"
export * from "./CardFieldWrap.vue?vue&type=script&lang=js"
import style0 from "./CardFieldWrap.vue?vue&type=style&index=0&id=fa7c4226&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7c4226",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa7c4226')) {
      api.createRecord('fa7c4226', component.options)
    } else {
      api.reload('fa7c4226', component.options)
    }
    module.hot.accept("./CardFieldWrap.vue?vue&type=template&id=fa7c4226&scoped=true", function () {
      api.rerender('fa7c4226', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/primer/localCardList/customFields/CardFieldWrap.vue"
export default component.exports